import { axiosBearer } from './axiosInstances.js'

export async function getBlogPost(boxes, postId = '') {
  const response = await axiosBearer.get(
    `/posts/${boxes ? 1 : 0}${postId !== null ? `?postId=${postId}` : ''}`
  )
  return response.data.result
}
